import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { serverApi } from '../../api';
import { EmpresaFormFields } from '../../components/EmpresaFormFields';

const MySwal = withReactContent(Swal);

const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: 10,
    border: '1.5px solid #cbd5e1', marginTop: 4, boxSizing: 'border-box',
    fontSize: 14, fontFamily: "'Inter', Arial, sans-serif", background: 'white',
};

export const NuevaEmpresaModal = ({ show, onClose, onSuccess, vendedores = [], preselectedVendedor = '', preciosConfig }) => {
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        codigoEntidad: '',
        nombreEntidad: '',
        nit: '',
        imagenLogo: '',
        imagenIcono: '',
        llamadoVoz: 0,
        voz: 'es-CO',
        telefonoContacto: '',
        emailContacto: '',
        direccion: '',
        ciudad: '',
        maxSedes: 1,
        indActivo: 1,
        codigoVendedor: preselectedVendedor || '',
        // Primer Administrador
        adminUsuario: '',
        adminNombre: '',
        adminPassword: '',
    });

    useEffect(() => {
        if (preselectedVendedor) {
            setForm(prev => ({ ...prev, codigoVendedor: preselectedVendedor }));
        }
    }, [preselectedVendedor]);

    if (!show) return null;

    // Cálculo de precio
    const base = Number(preciosConfig?.precioBaseSede || 500000);
    const adicional = Number(preciosConfig?.precioPorSedeAdicional || 100000);
    const sedesAdicionales = Math.max(0, Number(form.maxSedes || 1) - 1);
    const precioTotal = base + (sedesAdicionales * adicional);

    const handleChange = (e) => {
        const { id, value, type } = e.target;
        setForm(prev => ({
            ...prev,
            [id]: type === 'number' || id === 'llamadoVoz' || id === 'maxSedes' || id === 'indActivo'
                ? Number(value) : value,
        }));
    };

    const handleImageChange = (changes) => {
        setForm(prev => ({ ...prev, ...changes }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.codigoEntidad || !form.nombreEntidad || !form.adminUsuario || !form.adminPassword) {
            return MySwal.fire('Atención', 'Complete todos los campos obligatorios (*)', 'warning');
        }
        try {
            setLoading(true);
            const resp = await serverApi.post('/superadmin/entidades', form);
            if (resp.data.ok) {
                MySwal.fire({
                    title: '¡Empresa Creada!',
                    text: resp.data.msg,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
                onSuccess();
                onClose();
            }
        } catch (error) {
            const msg = error.response?.data?.msg || 'Error al crear la empresa';
            MySwal.fire('Error', msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff', borderRadius: 24, width: '100%',
                maxWidth: 700, maxHeight: '92vh', overflowY: 'auto',
                boxShadow: '0 25px 60px rgba(0,0,0,0.25)', border: '1px solid #e2e8f0',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)',
                    padding: '24px 28px', color: 'white',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    position: 'sticky', top: 0, zIndex: 1,
                }}>
                    <div>
                        <h4 style={{ margin: 0, fontWeight: 800, fontSize: 20 }}>🏢 Crear Nueva Empresa / Entidad</h4>
                        <p style={{ margin: '4px 0 0', opacity: 0.85, fontSize: 13 }}>Asignación de sedes y primer usuario administrador</p>
                    </div>
                    <button onClick={onClose} style={{
                        background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white',
                        width: 36, height: 36, borderRadius: '50%', fontSize: 18, cursor: 'pointer',
                    }}>✕</button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: 28 }}>
                    {/* ── Campos comunes compartidos ── */}
                    <EmpresaFormFields
                        form={form}
                        onChange={handleChange}
                        onImageChange={handleImageChange}
                        isSuperAdmin={true}
                        readonlyCodigo={false}
                        accentColor="#0d7367"
                    />

                    {/* ── Campos exclusivos de CREACIÓN ── */}
                    <div style={{
                        fontSize: 12, fontWeight: 800, color: '#0d7367',
                        textTransform: 'uppercase', letterSpacing: 1,
                        marginBottom: 14, marginTop: 10,
                        borderBottom: '2px solid #d1fae5', paddingBottom: 6,
                    }}>
                        Asignación Comercial
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                        <div>
                            <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Número de Sedes Contratadas *</label>
                            <input
                                id="maxSedes"
                                type="number"
                                min="1"
                                value={form.maxSedes}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontWeight: 700, color: '#0d7367', fontSize: 16 }}
                            />
                        </div>
                        <div>
                            <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Vendedor Asignado</label>
                            <select
                                id="codigoVendedor"
                                value={form.codigoVendedor}
                                onChange={handleChange}
                                disabled={Boolean(preselectedVendedor)}
                                style={{ ...inputStyle, background: preselectedVendedor ? '#f1f5f9' : 'white' }}
                            >
                                <option value="">Sin Vendedor / Directo</option>
                                {vendedores.map(v => (
                                    <option key={v.codigoVendedor} value={v.codigoVendedor}>
                                        {v.nombreVendedor} ({v.codigoVendedor})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Calculadora de precio */}
                    <div style={{
                        background: 'linear-gradient(135deg, #ecfdf5 0%, #e6f4f2 100%)',
                        border: '1.5px solid #a7f3d0', borderRadius: 16,
                        padding: '16px 20px', marginBottom: 24,
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <div style={{ fontSize: 12, fontWeight: 800, color: '#047857', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                    💰 Valor Cotización Paquete
                                </div>
                                <div style={{ fontSize: 13, color: '#065f46', marginTop: 2 }}>
                                    Base 1ª Sede: <b>${base.toLocaleString('es-CO')}</b> · Sede adicional: <b>${adicional.toLocaleString('es-CO')}</b>
                                </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: 11, color: '#047857', fontWeight: 700 }}>VALOR TOTAL</div>
                                <div style={{ fontSize: 24, fontWeight: 900, color: '#0d7367' }}>
                                    ${precioTotal.toLocaleString('es-CO')} COP
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Primer Administrador */}
                    <div style={{
                        fontSize: 12, fontWeight: 800, color: '#0d7367',
                        textTransform: 'uppercase', letterSpacing: 1,
                        marginBottom: 14, borderBottom: '2px solid #d1fae5', paddingBottom: 6,
                    }}>
                        Administrador Inicial de la Empresa
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 24 }}>
                        <div>
                            <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Nombre Admin *</label>
                            <input id="adminNombre" type="text" value={form.adminNombre} onChange={handleChange}
                                placeholder="Ej: Carlos Pérez" required style={inputStyle} />
                        </div>
                        <div>
                            <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Usuario Login *</label>
                            <input id="adminUsuario" type="text" value={form.adminUsuario} onChange={handleChange}
                                placeholder="Ej: admin" required style={inputStyle} />
                        </div>
                        <div>
                            <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Contraseña *</label>
                            <input id="adminPassword" type="password" value={form.adminPassword} onChange={handleChange}
                                placeholder="••••••••" required style={inputStyle} />
                        </div>
                    </div>

                    {/* Botones */}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                        <button type="button" onClick={onClose} style={{
                            padding: '12px 20px', borderRadius: 12, border: '1.5px solid #cbd5e1',
                            background: 'white', color: '#475569', fontWeight: 700, cursor: 'pointer',
                        }}>Cancelar</button>
                        <button type="submit" disabled={loading} style={{
                            padding: '12px 28px', borderRadius: 12, border: 'none',
                            background: 'linear-gradient(135deg, #0d7367 0%, #14b8a6 100%)',
                            color: 'white', fontWeight: 800, cursor: loading ? 'not-allowed' : 'pointer',
                            boxShadow: '0 4px 14px rgba(13,115,103,0.3)',
                        }}>
                            {loading ? 'Creando Empresa...' : '✓ CREAR EMPRESA'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
